export const BUSINESS = {
  name: "Site Cleanup",
  email: "sitecleanup@imperiumtech.com.au",
  abn: "ABN pending",
  tagline: "Site Cleanup Quotes Across Melbourne. Vacant lot clean-up, builder waste removal and pre-build site preparation.",
};

export const SUBURBS = [
  { slug: "epping-vic", name: "Epping VIC", state: "VIC", postcode: "3076" },
  { slug: "wollert", name: "Wollert", state: "VIC", postcode: "3750" },
  { slug: "craigieburn", name: "Craigieburn", state: "VIC", postcode: "3064" },
  { slug: "mickleham", name: "Mickleham", state: "VIC", postcode: "3064" },
  { slug: "donnybrook", name: "Donnybrook", state: "VIC", postcode: "3064" },
  { slug: "mernda", name: "Mernda", state: "VIC", postcode: "3754" },
  { slug: "south-morang", name: "South Morang", state: "VIC", postcode: "3752" },
  { slug: "tarneit", name: "Tarneit", state: "VIC", postcode: "3029" },
  { slug: "clyde", name: "Clyde", state: "VIC", postcode: "3978" },
  { slug: "werribee", name: "Werribee", state: "VIC", postcode: "3030" },
  { slug: "melbourne-metro", name: "Melbourne Metro", state: "VIC", postcode: "" },
  { slug: "regional-victoria", name: "Regional Victoria", state: "VIC", postcode: "" },
];

export const SERVICES = [
  { slug: "vacant-lot-and-pre-build-clean-up", title: "Vacant lot & pre-build clean-up", blurb: "Clear dumped rubbish, overgrown debris, packaging and loose materials from vacant lots and blocks so they're ready for the builder to start on time." },
  { slug: "builder-waste-and-construction-debris-removal", title: "Builder waste & construction debris removal", blurb: "Timber offcuts, plasterboard, bricks, tiles, straps, cartons, plastic wrap and general site rubbish — cleared during and between build stages." },
  { slug: "end-of-build-tidy", title: "End-of-build tidy-up", blurb: "Final site tidy before handover, inspection, photography, landscaping or settlement." },
  { slug: "land-clearing-preparation", title: "Land clearing preparation", blurb: "Clear light vegetation, loose debris and surface rubbish to prep a lot for machinery." },
];

export const STATES = ["VIC", "NSW", "QLD", "SA", "WA", "TAS", "NT", "ACT"];

export const CUSTOMER_TYPES = ["Homeowner", "Land buyer", "Builder", "Supervisor", "Developer", "Other"];

export const JOB_TYPES = [
  "Vacant lot & pre-build clean-up",
  "Builder waste & construction debris removal",
  "End-of-build tidy",
  "Land clearing preparation",
  "Skip bin hire",
  "Other",
];

export const TIMEFRAMES = ["ASAP", "This week", "This month", "Flexible"];

export const YES_NO_NOTSURE = ["Yes", "No", "Not sure"];

export const LEAD_STATUSES = ["New", "Contacted", "Quote Requested", "Sent to Contractor", "Won", "Lost", "Not Suitable"];

export const statusPillClass = (s) => ({
  "New": "pill-new",
  "Contacted": "pill-contacted",
  "Quote Requested": "pill-quote",
  "Sent to Contractor": "pill-sent",
  "Won": "pill-won",
  "Lost": "pill-lost",
  "Not Suitable": "pill-notsuitable",
}[s] || "pill-new");
